import React, {Fragment, useEffect} from "react";
import { Route, Routes } from "react-router-dom";


function AppUnprotected() {

  let relevantQrRoutes = [

  ]

  return (
    <>
    <Fragment>
      <div style={{width: "100%" }}>
        <div
          style={{width: "100%" }}
        >
          <Routes>
            {relevantQrRoutes.map(
              (route) =>
                  <Route
                    key={route.key}
                    path={route.path}
                    element={
                      <route.component  />
                    }
                  />
                )
            }
          </Routes>
        </div>
      </div>
    </Fragment>
  </>
  );
}

export default AppUnprotected;
